import { NavLink } from 'react-router-dom';
import { useEffect, useState, useRef } from 'react';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import { BackendLink } from "../../../Components";
import fallbackServices from "../../../Data/fallbackServices";
import './NestedMegaMenu.css';



const NestedMegaMenu = ({ isMegaMenuOpen, setIsOpen }) => {
    const [servicesData, setServicesData] = useState([]);
    const [loading, setLoading] = useState(true);
    const menuRef = useRef(null);

    useEffect(() => {
        const fetchServicesData = async () => {
            try {
                const response = await fetch(`${BackendLink}/AllServices/`);
                if (!response.ok) throw new Error('Network response was not ok');
                const data = await response.json();

                // 👇 Handle empty data response
                if (Array.isArray(data) && data.length > 0) {
                    setServicesData(data);
                } else {
                    setServicesData(fallbackServices); // Set fallback if API returns empty
                }
            } catch (err) {
                setServicesData(fallbackServices); // Set fallback on error
            } finally {
                setLoading(false);
            }
        };
        fetchServicesData();
    }, []);


    useEffect(() => {
        const menu = menuRef.current;
        if (!menu) return;

        const isMobile = window.innerWidth <= 992;
        if (isMobile) {
            if (isMegaMenuOpen) {
                menu.style.height = 'auto';
                const scrollHeight = menu.scrollHeight;
                menu.style.height = '0px';
                setTimeout(() => {
                    menu.style.height = `${scrollHeight}px`;
                }, 0);
            } else {
                menu.style.height = '0px';
            }
        } else {
            menu.style.height = 'auto';
        }
    }, [isMegaMenuOpen]);

    if (loading) return <></>; // loading state, can be replaced with a spinner or placeholder

    return (
        <ul ref={menuRef} className={`nested-megaMenu ${isMegaMenuOpen ? 'opened' : ''}`}>
            {servicesData.map(({ id, txt, isFake }) => (
                <li key={id} className="mega-item">
                    {isFake ? (
                        <div
                            className="mega-link"
                            onClick={() => {
                                alert('Sorry, server not response or no data Found');
                                setIsOpen(false);
                            }}
                            style={{ cursor: 'pointer' }}
                        >
                            <div className="item-content">
                                <IoMdCheckmarkCircleOutline size={20} color='var(--color-primary)' />
                                <div className="item-text d-flex align-items-center justify-content-between gap-1">  
                                    {txt}
                                </div>
                            </div>
                        </div>
                    ) : (
                        <NavLink
                            to={`/Services/${id}`}
                            className="mega-link"
                            onClick={() => setIsOpen(false)}
                        >
                            <div className="item-content">
                                <IoMdCheckmarkCircleOutline size={20} color='var(--color-primary)' />
                                <div className="item-text">
                                    {txt}
                                </div>
                            </div>
                        </NavLink>
                    )}
                </li>
            ))}
        </ul>
    );
};

export default NestedMegaMenu;

